
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
// Css
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import "../node_modules/slick-carousel/slick/slick.css"; 
import "../node_modules/slick-carousel/slick/slick-theme.css";
import '../node_modules/magnific-popup/dist/magnific-popup.css';
import "../node_modules/react-datepicker/dist/react-datepicker.css";
import './assets/css/animate.min.css';
import './assets/css/font-awesome.min.css';
import './assets/css/flaticon.css';
import './assets/css/default.css';
import './assets/css/style.css';
import './index.css';

window.addEventListener('error', function(e) {
  if (e.message && e.message.includes('Loading chunk')) {
    window.location.reload();
  }
});

// ✅ Use React 18 createRoot API
const root = ReactDOM.createRoot(document.getElementById('miranda'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Optional: web vitals
reportWebVitals();
